export { clearCustomerJourneyCookie, getCustomerJourneyCookie, saveCustomerJourneyCookie } from "./lib/shared-customer-journey-cookies";
